import { LayoutWithSidebar } from 'utils/router/components/LayoutWithSidebar/LayoutWithSidebar'
import { getHandle } from 'utils/router/utils/getHandle'

export const AudienceRoutes = [
  {
    path: 'subscribers/:user_id?',
    alias: 'subscribers',
    handle: getHandle('contacts'),
    Component: LayoutWithSidebar,
    children: [
      {
        index: true,
        lazy: () => import('./audience.page'),
      },
      {
        path: 'merge/:secondary_id?',
        alias: 'subscribersMerge',
        lazy: () => import('./audience.page'),
      },
    ],
  },
] as const
